export default __webpack_public_path__ + "static/media/tile.fc0e8254.svg";